<template>
<div ref="mv" class="p-lp__mv">
    <div class="c-mv" :style="setMvHeight">
        <div class="c-mv__bg">
            <video playsinline loop autoplay muted>
                <source media="(max-width: 800px)" src="/lp/assets/video/mv-sp.mp4" alt="" type="video/mp4">
                <source src="/lp/assets/video/mv-pc.mp4" alt="" type="video/mp4">
            </video>
        </div>
        <div class="c-mv__logo">
            <img src="/lp/assets/img/common/logo.png" alt="WITH EARTH GARDEN" width="174" height="122">
        </div>
        <div class="c-mv__title">
            <h2>千葉ベイエリアならみつかる、憧れの住まい</h2>
            <h1>ウィザースガーデンの<br>新築一戸建て住宅を<br>見に行こう！</h1>
        </div>
    </div>
</div>
</template>

<script>

import { gsap, Quart } from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default {
    data() {
        return {
            mvWidth: 0,
            mvHeight: 0,
        }
    },
    computed: {
        setMvHeight() {
            if (this.mvHeight > 0) {
                return `height: ${this.mvHeight}px;`;
            } else {
                return '';
            }
        }
    },
    mounted() {
        const timeline = gsap.fromTo(
            this.$el.querySelector('.c-mv__bg'), {
                y: '0%',
            }, {
                y: '50%',
                ease: 'none',
                scrollTrigger: {
                    // id: 'gallery-pallarax',
                    trigger: this.$el,//galleryContainer.value,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true,
                    invalidateOnRefresh: true,
                }
            }
        );

        this.resize();
        window.addEventListener('resize', this.resize);
    },
    methods: {
        resize() {
            if (window.matchMedia('(max-width: 800px)').matches) {
                //SP
                if (this.mvWidth !== window.innerWidth) {
                    this.mvHeight = innerHeight;
                }
            } else {
                //PC
                this.mvHeight = 0;
            }

            this.mvWidth = window.innerWidth;
        }
    }
}

</script>